import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Error404 from '../../components/App/Error404'
import Home from '../Home'
import SignIn from '../User/SignIn'
import SignOn from '../User/SignOn'

export default function GuestRoutes(props) {
  return <Switch>
    <Route
      exact
      path="/"
      component={Home}
    />
    <Route
      path="/home"
      component={Home}
    />
    <Route
      path="/signin"
      component={SignIn}
    />
    <Route
      path="/signon"
      component={SignOn}
    />
    <Route path="/" component={Error404} />
  </Switch>
}